import cn from 'classnames'
import { EnterpriseAnnouncementModal } from '@mc/enterprise-announcement'
import { useTranslation } from '@mc/i18n'
import { useUserInfo } from '@mc/user-info'
import Link from 'components/Link'
import { businessAdminPath } from 'libs/paths'
import { trackNavClick } from '../events'
import classes from './AdminLink.module.scss'

const isActive = () =>
  typeof window !== 'undefined' &&
  window.location.href.includes(businessAdminPath())

export const AdminLink = ({ className = '' }: { className?: string }) => {
  const { t } = useTranslation('@mc/next')
  const { user } = useUserInfo()

  const isEnterpriseAdmin = !!user?.organizationsAdministered?.length

  return (
    <>
      <Link
        isBasic
        href={businessAdminPath()}
        className={cn('d-inline-flex mc-text-h6', classes.item, className, {
          [classes.activeItem]: isActive(),
          [classes.visibleItem]: isEnterpriseAdmin,
        })}
        onClick={trackNavClick('Admin')}
      >
        {t('nav.cta.admin')}
      </Link>

      <EnterpriseAnnouncementModal />
    </>
  )
}
